import { gql, type TypedDocumentNode } from '@apollo/client';
import { type Address } from '../components/ProviderProfile/interfaces';

export const PROFILE_DETAILS_QUERY: TypedDocumentNode<ProfileDetailsQueryData, ProfileDetailsQueryVars> = gql`
    query PROVIDER_DETAILS_QUERY($providerId: Long!) {
        provider(id: $providerId) {
            id
            providerId
            businessNumber
            contactInfo {
                mailingAddresses {
                    countryCode
                    countryName
                    zIP_Postal
                    state_ProvinceCode
                }
            }
        }
    }
`

export interface ProfileDetailsQueryData {
    provider: {
        id: number
        providerId: number
        contactInfo?: {
            mailingAddresses: Address[]
        }
    }
}

export interface ProfileDetailsQueryVars {
    providerId: number
}
